import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { rf } from "../theme";
import BrandLogo from "../BrandLogo";

const COLUMNS = [
  {
    title: "Reinforce",
    links: [
      { label: "Running cohorts", href: "#cohorts" },
      { label: "Curriculum", href: "#curriculum" },
      { label: "How a week runs", href: "#rhythm" },
      { label: "FAQ", href: "#faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms", to: "/interview-prep/terms" },
      { label: "Privacy", to: "/interview-prep/privacy" },
      { label: "Refunds", to: "/interview-prep/refund" },
    ],
  },
];

export const SiteFooter = () => {
  const navigate = useNavigate();

  return (
    <Box component="footer" sx={{ backgroundColor: rf.ink, color: "#fff", borderTop: rf.line, py: { xs: 5, md: 7 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <BrandLogo size="medium" mono sx={{ color: "#fff", mb: 2 }} />
            <Typography sx={{ fontFamily: rf.body, fontSize: 14.5, color: "rgba(255,255,255,0.72)", lineHeight: 1.65, maxWidth: 340 }}>
              Cohort-based AI and data science coaching. Live classes, capped batches, the whole syllabus published
              before you pay.
            </Typography>
          </Grid>

          {COLUMNS.map((col) => (
            <Grid item xs={6} md={3} key={col.title}>
              <Typography sx={{ fontFamily: rf.display, fontSize: 11.5, fontWeight: 800, letterSpacing: "0.09em", textTransform: "uppercase", color: rf.amber, mb: 1.75 }}>
                {col.title}
              </Typography>
              <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0, display: "flex", flexDirection: "column", gap: 1.1 }}>
                {col.links.map((link) => (
                  <Box component="li" key={link.label}>
                    <Box
                      component="a"
                      href={link.href || link.to}
                      onClick={(e) => {
                        if (link.to) {
                          e.preventDefault();
                          navigate(link.to);
                        }
                      }}
                      sx={{
                        fontFamily: rf.body,
                        color: "rgba(255,255,255,0.8)",
                        fontSize: 14.5,
                        textDecoration: "none",
                        cursor: "pointer",
                        "&:hover": { color: rf.amber },
                      }}
                    >
                      {link.label}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>

        <Typography
          sx={{
            fontFamily: rf.body,
            mt: 5,
            pt: 3,
            borderTop: "2px solid rgba(255,255,255,0.18)",
            fontSize: 13.5,
            color: "rgba(255,255,255,0.6)",
          }}
        >
          © {new Date().getFullYear()} Edgent. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default SiteFooter;
